import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsInlineSkateNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.98 23.67a2.664 2.664 0 10-.01-5.328 2.664 2.664 0 00.01 5.328zm0-3.98a1.32 1.32 0 110 2.64 1.32 1.32 0 010-2.64zm15.36 1.32a2.665 2.665 0 105.33-.01 2.665 2.665 0 00-5.33.01zm3.99 0a1.32 1.32 0 11-1.32-1.32 1.333 1.333 0 011.32 1.32zm-10 0a2.67 2.67 0 105.34 0 2.67 2.67 0 00-5.34 0zm3.99 0A1.32 1.32 0 1115 19.69a1.333 1.333 0 011.32 1.32zm-10 0a2.67 2.67 0 105.34 0 2.67 2.67 0 00-5.34 0zm3.99 0a1.32 1.32 0 11-2.641 0 1.32 1.32 0 012.64 0zm-9.11-4.9a3.754 3.754 0 002.89 1.35h15.42a3.188 3.188 0 003.18-3.18 2.5 2.5 0 00-1.32-2.2L10.7 6.37l.67-3.56A2.09 2.09 0 009.3.33H7.23l-1.34 2H2.22L.36 13.02a3.764 3.764 0 00.84 3.09zm19.53-2.84a1.14 1.14 0 01.61 1.01 1.83 1.83 0 01-1.83 1.83h-2.023l1.857-3.578 1.386.738zM3.35 3.67h3.26l1.34-2H9.3a.739.739 0 01.58.28.755.755 0 01.16.61l-.661 3.5h-2.43v1.35h2.829l3.8 2.036L12.1 12.33h1.52l1.15-2.24 3.384 1.8-2.189 4.22H8.326a4.463 4.463 0 00-4.451-4.31H1.939L3.35 3.67zm-1.66 9.58l.019-.1h2.166a3.113 3.113 0 013.1 2.957H4.09a2.446 2.446 0 01-2.4-2.86v.003z"
        fill=""
      />
    </svg>
  )
);
SvgSportsInlineSkateNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsInlineSkateNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsInlineSkateNormalSmall;
